'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$0024anon$00246 from "./presto.-Fetcher$$anon$6.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024 from "./presto.-Fetcher$-Unified-Error-Format$.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$5() {
  this.aSM = null;
  this.aSE = null;
  this.aSF = false;
  this.aSN = null;
  this.aSO = false;
  this.aSR = null;
  this.aSK = null;
  this.aSL = false;
  this.aSG = null;
  this.aSH = false;
  this.aSI = null;
  this.aSJ = false;
  this.aSP = false;
  this.aSQ = false;
  this.aSM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aSR = "UnifiedErrorFormat";
}
export { $c_Lpresto_Fetcher$$anon$5 as $c_Lpresto_Fetcher$$anon$5 };
$p = $c_Lpresto_Fetcher$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$$anon$5;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$5() {
}
export { $h_Lpresto_Fetcher$$anon$5 as $h_Lpresto_Fetcher$$anon$5 };
$h_Lpresto_Fetcher$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aSM;
});
$p.L = (function() {
  if ((!this.aSF)) {
    this.aSE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aSF = true;
  }
  return this.aSE;
});
$p.O = (function() {
  if ((!this.aSO)) {
    this.aSN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aSO = true;
  }
  return this.aSN;
});
$p.E = (function() {
  return this.aSR;
});
$p.t = (function() {
  if ((!this.aSL)) {
    this.aSK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("status", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("trace", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aSL = true;
  }
  return this.aSK;
});
$p.M = (function() {
  if ((!this.aSH)) {
    this.aSG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aSH = true;
  }
  return this.aSG;
});
$p.Q = (function() {
  if ((!this.aSJ)) {
    this.aSI = new $j_presto$002e$002dFetcher$0024$0024anon$00246.$c_Lpresto_Fetcher$$anon$6();
    this.aSJ = true;
  }
  return this.aSI;
});
$p.w = (function() {
  if ((!this.aSQ)) {
    this.aSP = false;
    this.aSQ = true;
  }
  return this.aSP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee19) => ((p) => \u03b4scrutinee19.cG0(p)))($j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024.$m_Lpresto_Fetcher$UnifiedErrorFormat$())));
});
var $d_Lpresto_Fetcher$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$5, "presto.Fetcher$$anon$5", ({
  It: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Fetcher$$anon$5 as $d_Lpresto_Fetcher$$anon$5 };
//# sourceMappingURL=presto.-Fetcher$$anon$5.js.map
